import React from 'react'
import axios from 'axios'

const GetAllTesi = () => {
    const [aalTesti, setaalTesti] = React.useState("")
    async function getData() {
        const plans = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/admin/get-all`)
        setaalTesti(plans.data.data)
    }
    React.useEffect(() => {
        getData()
    }, [])
    return { aalTesti }
}

export default GetAllTesi